import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import useDynamicSplitButtonCatchupLastViewedTimeQuery, {
	type useDynamicSplitButtonCatchupLastViewedTimeQuery$data,
	type useDynamicSplitButtonCatchupLastViewedTimeQuery$variables,
} from './hooks/__generated__/useDynamicSplitButtonCatchupLastViewedTimeQuery.graphql';

export function preloadAIFloatingContextMenu(contentId: string, isBlog: boolean) {
	const contentType = isBlog ? 'BLOGPOST' : 'PAGE';
	return query<
		useDynamicSplitButtonCatchupLastViewedTimeQuery$data,
		useDynamicSplitButtonCatchupLastViewedTimeQuery$variables
	>({
		query: useDynamicSplitButtonCatchupLastViewedTimeQuery,
		variables: {
			contentId,
			contentType,
		},
	});
}
